export type ProductBenefitBannersResponse = {
  product_benefit_banners: Array<{
    id: string;
    platform: {
      id: string;
      name: string;
      value: string;
    };
    pageType: {
      id: string;
      name: string;
      value: string;
    };
    type: string;
    headline: string;
    backgroundColor: string;
    benefits: Array<{
      product_benefits_id: {
        tooltipText: string;
        keyfact: string;
        headline: string;
        icon: {
          id: string;
          filename_disk: string;
        };
      };
    }>;
  }>;
};

export const productBenefitBanners = () => `
  product_benefit_banners(
    filter: {
      status: {
        _eq: "published"
      },
      platform: {
        agent: {
          _eq: "${import.meta.env.VITE_PORTAL}"
        }
      },
      pageType: {
        value: {
          _eq: "sea"
        }
      },
    },
    limit: 1
  ) {
    id
    platform {
      id
      name
      value
    }
    pageType {
      id
      name
      value
    }
    type
    headline
    backgroundColor
    benefits {
      product_benefits_id {
        tooltipText
        keyfact
        headline
        icon {
          id
          filename_disk
        }
      }
    }
  }
`;
